const getTheDayBefore = (dateTime: string) => {
  const d = new Date(dateTime);
  const theDayBefore = d.setDate(d.getDate() - 1);
  return new Date(theDayBefore);
};

export default getTheDayBefore;
